import { render, staticRenderFns } from "./WelfareSetMealList.vue?vue&type=template&id=61bd3bef&scoped=true"
import script from "./WelfareSetMealList.vue?vue&type=script&lang=js"
export * from "./WelfareSetMealList.vue?vue&type=script&lang=js"
import style0 from "./WelfareSetMealList.vue?vue&type=style&index=0&id=61bd3bef&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bd3bef",
  null
  
)

export default component.exports